import { useMemo, useReducer } from 'react'
import { getBlobAsync } from '../shared/api.service'

export const types = {
  INIT: 'INIT',
  ERROR: 'ERROR',
  SUBMIT: 'SUBMIT',
  GET_SUCCESS: 'GET_SUCCESS',
  POST_SUCCESS: 'POST_SUCCESS',
  PUT_SUCCESS: 'PUT_SUCCESS',
  DELETE_SUCCESS: 'DELETE_SUCCESS'
}

export const initialState = {
  blob: undefined,
  // The response's Last-Modified (an HTTP date), when the server sends one:
  // when the stored file was last saved (storage's file-public logo).
  lastModified: undefined,
  loading: false,
  submitting: false,
  error: undefined
}

const reducer = (state, action) => {
  switch (action.type) {
    case types.INIT:
      return { ...initialState }
    case types.ERROR:
      return { ...state, loading: false, submitting: false, error: action.payload }
    case types.SUBMIT:
      return { ...state, loading: false, submitting: true, error: undefined }
    case types.GET_SUCCESS:
      return { ...state, blob: action.payload, lastModified: action.lastModified, loading: false, submitting: false, error: undefined }
    default:
      return state
  }
}

export const useApiBlob = (server, endpoint) => {
  const [state, dispatch] = useReducer(reducer, initialState)

  const actions = useMemo(() => {
    return {
      init: () => initAction(dispatch)(),
      get: arg => getAction(server, endpoint, dispatch)(arg)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return useMemo(
    () => {
      return { ...state, ...actions }
    },
    [state, actions]
  )
}

const initAction = dispatch => async () => {
  dispatch({ type: types.INIT })
}

const getAction = (server, endpoint, dispatch) => async arg => {
  try {
    if (arg) {
      endpoint = `${endpoint}/${arg}`
    }

    dispatch({ type: types.SUBMIT })
    var result = await getBlobAsync(server, endpoint)
    const lastModified = (result.headers && result.headers['last-modified']) || undefined
    dispatch({ type: types.GET_SUCCESS, payload: result.data, lastModified })
    return result.data
  } catch (exception) {
    dispatch({ type: types.ERROR, payload: exception.error || '' })
  }
}
